import React from 'react';
import UiCardImage from '../../../ui/CardImage';
import CardOverlays from '../../../ui/CardOverlays';
import CardContextMenu from './CardContextMenu';

/**
 * Einzelne Commander-Karte der Kommandobrücke. Rendert über `ui/CardImage` (Flip bei
 * doppelseitigen Commandern inklusive) + ein Glas-⋮-Menü (`CardContextMenu`
 * mit `overlayTrigger`, komponiert `ui/ContextMenu`). Kein `onSetCommander`/`onNewLabel`
 * — dadurch zeigt das Menü weder „Als Commander setzen" noch die Label-Sektion
 * (beide rendert `CardContextMenu` nur bei vorhandenem Handler), nur „Details",
 * „Print wechseln" und „Commander entfernen" (via `extraItems`). Im fremden Deck
 * bleibt „Details" übrig: die mutierenden Einträge hängen an `isOwnProfile`.
 * `overlayExtra` ist ein optionaler zusätzlicher Overlay-Slot neben dem
 * Menü-Trigger (z.B. der Zuklapp-Chip der Kommandobrücke). Ohne `imageWidthPx` setzt der Wrapper keine
 * Inline-Breite — die Breite bestimmt dann der Konsument per CSS (Flex-Stretch,
 * `width: 100%` o.ä.).
 */
export default function CommanderCardWithMenu({
  card,
  deckId, // kept for API-compat / future use
  onRemove,
  onShowDetails,
  onSwitchPrint,
  isOwnProfile,
  imageWidthPx,
  overlayExtra,
}) {
  return (
    <div style={imageWidthPx ? { width: imageWidthPx } : undefined}>
      <UiCardImage src={card.imageUrl} backSrc={card.imageUrlBack} alt={card.name}>
        {(isOwnProfile || (onShowDetails && card.oracleId)) && (
          <CardOverlays>
            <CardOverlays.Actions>
              <CardContextMenu
                overlayTrigger
                card={card}
                onShowDetails={onShowDetails && card.oracleId ? () => onShowDetails(card) : undefined}
                onSwitchPrint={onSwitchPrint && card.oracleId ? () => onSwitchPrint(card) : undefined}
                extraItems={isOwnProfile ? [{ label: 'Commander entfernen', onClick: () => onRemove(card.id) }] : []}
              />
              {overlayExtra}
            </CardOverlays.Actions>
          </CardOverlays>
        )}
      </UiCardImage>
    </div>
  );
}
